(function () {
  'use strict';

  /**
   * Element.closest() from an event target that may not be an Element.
   * event.target is `document` for a document-level mouseenter and can be a
   * text node elsewhere; calling .closest() on those throws a TypeError that
   * aborts the handler. Delegates to MMCompat when the compat layer is loaded.
   */
  function targetClosest(e, selector) {
    if (window.MMCompat && window.MMCompat.closestFrom) {
      return window.MMCompat.closestFrom(e && e.target, selector);
    }
    var node = e && e.target;
    while (node && node.nodeType !== 1) node = node.parentElement || node.parentNode || null;
    return node && typeof node.closest === 'function' ? node.closest(selector) : null;
  }

  function initMobileHome(root) {
    if (!root || root.dataset.mmHomeInit === '1') return;
    root.dataset.mmHomeInit = '1';

    var list = root.querySelector('[data-mmh-products]');
    var cards = list
      ? Array.prototype.slice.call(list.querySelectorAll('[data-mmh-product]'))
      : [];
    var chips = root.querySelectorAll('[data-mmh-chip]');
    var sortSelect = root.querySelector('[data-mmh-sort-select]');
    var countEl = root.querySelector('[data-mmh-count]');
    var loadMoreWrap = root.querySelector('[data-mmh-load-more-wrap]');
    var loadMoreBtn = root.querySelector('[data-mmh-load-more]');
    var loadMoreHint = root.querySelector('[data-mmh-load-more-hint]');
    var pageSize = parseInt((list && list.getAttribute('data-mmh-page-size')) || '36', 10) || 36;
    var revealedCount = pageSize;
    var prefetchState = {
      nextPage: 2,
      pages: 1,
      loading: false,
      done: false
    };

    function syncOverlayClass() {
      var filterOverlay = document.getElementById('mmhFilterOverlay');
      var open = filterOverlay && filterOverlay.classList.contains('is-open');
      document.documentElement.classList.toggle('mmh-overlay-open', !!open);
    }
    var threshold = parseInt(root.getAttribute('data-free-threshold'), 10) || 20000;
    var freeChip = root.querySelector('[data-mmh-free-chip]');
    var recentSection = root.querySelector('[data-mmh-recent-section]');
    var recentTrack = root.querySelector('[data-mmh-recent-track]');

    var state = {
      filter: 'all',
      sort: 'featured',
      search: '',
      brands: [],
      catalogHandles: [],
      priceMin: null,
      priceMax: null
    };

    var productIndex = [];

    function rebuildProductIndex() {
      productIndex = [];
      if (!cards.length) return;
      cards.forEach(function (card) {
        var titleEl = card.querySelector('.mmh-product__title');
        var vendorEl = card.querySelector('.mmh-product__vendor');
        var imgEl = card.querySelector('.mmh-product__img img');
        var priceEl = card.querySelector('[data-mmh-product-price]');
        var linkEl = card.querySelector('.mmh-product__title-link, .mmh-product__img');
        productIndex.push({
          el: card,
          title: titleEl ? titleEl.textContent.trim() : card.getAttribute('data-title') || '',
          titleLower: titleEl ? titleEl.textContent.trim().toLowerCase() : '',
          brand: vendorEl ? vendorEl.textContent.trim() : '',
          brandLower: vendorEl ? vendorEl.textContent.trim().toLowerCase() : '',
          vendor: (card.getAttribute('data-vendor') || '').toLowerCase(),
          handle: (card.getAttribute('data-handle') || '').toLowerCase(),
          img: imgEl ? imgEl.currentSrc || imgEl.src : '',
          price: priceEl ? priceEl.innerHTML : '',
          url: linkEl && linkEl.href ? linkEl.href : ''
        });
      });
    }

    function handleFromCollectionUrl(url) {
      if (!url) return '';
      var m = String(url).match(/\/collections\/([^/?#]+)/i);
      return m ? m[1] : '';
    }

    function getSelectedBrandValues(scope) {
      var set = {};
      var selector =
        scope === 'desktop'
          ? '#mmhDesktopBrands input:checked'
          : scope === 'mobile'
            ? '#mmhMobileBrands input:checked'
            : '#mmhDesktopBrands input:checked, #mmhMobileBrands input:checked';
      root.querySelectorAll(selector).forEach(function (input) {
        if (input.value) set[String(input.value).toLowerCase()] = true;
        var t = input.getAttribute('data-brand-title');
        if (t) set[t.toLowerCase().replace(/[^a-z0-9]+/g, '-')] = true;
      });
      return Object.keys(set);
    }

    function getSelectedCatalogHandles(scope) {
      var handles = [];
      var containers = [];
      if (scope === 'desktop' || scope === 'all') {
        var d = document.getElementById('mmhDesktopCatalogGroups');
        if (d) containers.push(d);
      }
      if (scope === 'mobile' || scope === 'all') {
        var m = document.getElementById('mmhMobileCatalogFilters');
        if (m) containers.push(m);
      }
      containers.forEach(function (container) {
        container.querySelectorAll('.mm-cf-btn.is-on').forEach(function (btn) {
          var h = handleFromCollectionUrl(btn.getAttribute('data-url'));
          if (h && handles.indexOf(h) === -1) handles.push(h);
        });
      });
      return handles;
    }

    function readPriceFromInputs(minEl, maxEl) {
      var min = minEl && minEl.value ? parseFloat(minEl.value) * 100 : null;
      var max = maxEl && maxEl.value ? parseFloat(maxEl.value) * 100 : null;
      if (min !== null && isNaN(min)) min = null;
      if (max !== null && isNaN(max)) max = null;
      return { min: min, max: max };
    }

    function currentCountry() {
      var html = document.documentElement;
      var body = document.body;
      var currency = '';
      if (html && html.getAttribute) currency = html.getAttribute('data-mm-currency') || '';
      try {
        currency = currency || localStorage.getItem('mm_display_currency_user') || '';
      } catch (e) {}
      if (String(currency).toUpperCase() === 'SAR') return 'SA';

      var country = '';
      if (body && body.getAttribute) country = body.getAttribute('data-mm-country') || '';
      if (!country && html && html.getAttribute) country = html.getAttribute('data-mm-country') || '';
      return String(country || 'BH').trim().toUpperCase() || 'BH';
    }

    function freeDeliveryEnabled() {
      var key = currentCountry() === 'SA' ? 'freeDeliverySa' : 'freeDeliveryBh';
      return root.dataset[key] === '1';
    }

    function syncFreeDeliveryUi() {
      var enabled = freeDeliveryEnabled();
      if (freeChip) {
        freeChip.hidden = !enabled;
        if (!enabled && freeChip.classList.contains('is-active')) {
          freeChip.classList.remove('is-active');
          var allChip = root.querySelector('[data-mmh-chip="all"]');
          if (allChip) allChip.classList.add('is-active');
        }
      }
      root.querySelectorAll('[data-mmh-free-badge]').forEach(function (badge) {
        badge.hidden = !enabled;
      });
      if (!enabled && state.filter === 'free') state.filter = 'all';
    }

    function cardMatchesCollection(card, colHandle) {
      if (!colHandle) return false;
      var raw = (card.getAttribute('data-cats') || '').trim();
      if (!raw) return false;
      return raw.split(/\s+/).indexOf(colHandle) !== -1;
    }

    function vendorMatchesBrands(vendor, brands) {
      if (!brands.length) return true;
      if (!vendor) return false;
      var v = String(vendor).toLowerCase();
      return brands.some(function (b) {
        if (v === b) return true;
        if (v.indexOf(b) !== -1 || b.indexOf(v) !== -1) return true;
        return false;
      });
    }

    function cardMatchesAdvCollections(card, handles) {
      if (!handles.length) return true;
      var raw = (card.getAttribute('data-cats') || '').trim();
      if (!raw) return false;
      var cats = raw.split(/\s+/);
      return handles.some(function (h) {
        return cats.indexOf(h) !== -1;
      });
    }

    function productMatchesSearch(card, query) {
      if (!query) return true;
      var title = card.getAttribute('data-title') || '';
      var vendor = card.getAttribute('data-vendor') || '';
      var handle = card.getAttribute('data-handle') || '';
      var hay = (title + ' ' + vendor + ' ' + handle).trim();
      if (window.MMSmartSearch && typeof window.MMSmartSearch.matchesFuzzySearch === 'function') {
        return window.MMSmartSearch.matchesFuzzySearch(query, hay);
      }
      var q = query.toLowerCase();
      return hay.toLowerCase().indexOf(q) !== -1;
    }

    function cardPassesFilters(card) {
      var show = true;
      var isSale = card.getAttribute('data-sale') === 'true';
      var isFree = card.getAttribute('data-free') === 'true';

      if (show && state.filter === 'offers' && !isSale) show = false;
      if (show && state.filter === 'free' && !isFree) show = false;
      if (show && state.filter.indexOf('col:') === 0) {
        var colHandle = state.filter.slice(4);
        if (!cardMatchesCollection(card, colHandle)) show = false;
      }

      if (show && state.search && !productMatchesSearch(card, state.search)) show = false;
      if (show && state.brands.length && !vendorMatchesBrands(card.getAttribute('data-vendor') || '', state.brands)) {
        show = false;
      }
      if (show && state.catalogHandles.length && !cardMatchesAdvCollections(card, state.catalogHandles)) {
        show = false;
      }
      if (show && (state.priceMin !== null || state.priceMax !== null)) {
        var p = parseInt(card.getAttribute('data-price'), 10) || 0;
        if (state.priceMin !== null && p < state.priceMin) show = false;
        if (state.priceMax !== null && p > state.priceMax) show = false;
      }
      return show;
    }

    function applyFilters() {
      if (!list || !cards.length) return;
      syncFreeDeliveryUi();
      var matching = [];

      cards.forEach(function (card) {
        var show = cardPassesFilters(card);
        card.hidden = !show;
        if (!show) {
          card.removeAttribute('data-mmh-overflow');
          card.style.display = 'none';
          return;
        }
        matching.push(card);
      });

      matching.forEach(function (card, index) {
        var overflow = index >= revealedCount;
        if (overflow) {
          card.setAttribute('data-mmh-overflow', '1');
          card.style.display = 'none';
        } else {
          card.removeAttribute('data-mmh-overflow');
          card.style.display = '';
        }
      });

      if (countEl) countEl.textContent = String(matching.length);
      syncFilterBtnState();
      syncLoadMore(matching.length);
    }

    function syncLoadMore(matchingCount) {
      if (!loadMoreWrap) return;
      /* Only show when there are more matching products already in the list to reveal */
      var hasMoreVisible = matchingCount > revealedCount;
      loadMoreWrap.hidden = !hasMoreVisible;
      if (loadMoreHint) loadMoreHint.hidden = true;
      if (loadMoreBtn) {
        loadMoreBtn.disabled = false;
        loadMoreBtn.textContent =
          root.getAttribute('data-is-ar') === '1' ? 'تحميل المزيد' : 'Load more';
      }
    }

    function refreshCardsFromDom() {
      if (!list) return;
      cards = Array.prototype.slice.call(list.querySelectorAll('[data-mmh-product]'));
      rebuildProductIndex();
      bindVariantSelects();
      fitAllHomeProductImages();
      if (window.MMBranchInventory) window.MMBranchInventory.init(list);
    }

    function syncFilterBtnState() {
      var filterBtn = root.querySelector('[data-mmh-filter-open]');
      if (!filterBtn) return;
      var active =
        state.brands.length > 0 ||
        state.catalogHandles.length > 0 ||
        state.priceMin !== null ||
        state.priceMax !== null;
      filterBtn.classList.toggle('has-filters', active);
    }

    function syncSearchInputs(value) {
      root.querySelectorAll('[data-mmh-search-input], [data-mmh-desktop-search]').forEach(function (input) {
        if (input.value !== value) input.value = value;
      });
      var clearBtn = root.querySelector('[data-mmh-search-clear]');
      if (clearBtn) clearBtn.hidden = !value;
    }

    function runSearchUi(query) {
      state.search = String(query || '').trim();
      revealedCount = pageSize;
      syncSearchInputs(state.search);
      applyFilters();
    }

    function sortCards() {
      if (!list || !cards.length) return;
      cards = cards.slice().sort(function (a, b) {
        var pa = parseInt(a.getAttribute('data-price'), 10) || 0;
        var pb = parseInt(b.getAttribute('data-price'), 10) || 0;
        var ta = a.getAttribute('data-title') || '';
        var tb = b.getAttribute('data-title') || '';

        if (state.sort === 'price-asc') return pa - pb;
        if (state.sort === 'price-desc') return pb - pa;
        if (state.sort === 'name') return ta.localeCompare(tb);
        if (state.sort === 'new') {
          var na = parseInt(a.getAttribute('data-created'), 10) || 0;
          var nb = parseInt(b.getAttribute('data-created'), 10) || 0;
          return nb - na;
        }
        return 0;
      });

      cards.forEach(function (card) {
        list.appendChild(card);
      });
    }

    function refresh() {
      syncFreeDeliveryUi();
      sortCards();
      applyFilters();
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) {
          c.classList.remove('is-active');
        });
        chip.classList.add('is-active');
        state.filter = chip.getAttribute('data-mmh-chip') || 'all';
        state.catalogHandles = [];
        root.querySelectorAll('#mmhDesktopCatalogGroups .mm-cf-btn, #mmhMobileCatalogFilters .mm-cf-btn').forEach(function (btn) {
          btn.classList.remove('is-on');
        });
        var quickTabsEl = document.getElementById('mmhQuickTabs');
        if (quickTabsEl) {
          var tabs = quickTabsEl.querySelectorAll('.mmh-quick-tab');
          tabs.forEach(function (tab, idx) {
            tab.classList.toggle('on', idx === 0);
          });
        }
        revealedCount = pageSize;
        applyFilters();
      });
    });

    function fitHomeProductImage(img) {
      if (!img) return;
      var wrap = img.closest('.mmh-product__img');
      if (!wrap) return;
      var w = img.naturalWidth || 0;
      var h = img.naturalHeight || 0;
      if (!w || !h) {
        wrap.style.removeProperty('--mmh-img-ar');
        return;
      }
      var ar = w / h;
      /* Square stays ~1; portrait gets taller box; landscape stays near square */
      if (ar < 0.92) {
        ar = Math.max(0.72, ar);
      } else if (ar > 1.08) {
        ar = Math.min(1.12, ar);
      } else {
        ar = 1;
      }
      wrap.style.setProperty('--mmh-img-ar', String(ar));
    }

    function fitAllHomeProductImages() {
      root.querySelectorAll('[data-mmh-product-image]').forEach(function (img) {
        if (img.complete && img.naturalWidth) {
          fitHomeProductImage(img);
        } else {
          img.addEventListener(
            'load',
            function () {
              fitHomeProductImage(img);
            },
            { once: true }
          );
        }
      });
    }

    function bindVariantSelects() {
      root.querySelectorAll('[data-mmh-variant]').forEach(function (sel) {
        if (sel.dataset.mmhBound === '1') return;
        sel.dataset.mmhBound = '1';
        sel.addEventListener('change', function () {
          var card = sel.closest('[data-mmh-product]');
          if (!card) return;
          var btn = card.querySelector('[data-mmh-add]');
          var opt = sel.options[sel.selectedIndex];
          if (!btn || !opt || !opt.value) return;

          btn.setAttribute('data-variant-id', opt.value);
          btn.disabled = opt.disabled;

          var priceEl = card.querySelector('[data-mmh-product-price]');
          var compareEl = card.querySelector('[data-mmh-product-compare]');
          var pricesWrap = card.querySelector('.mmh-product__prices');
          var priceHtml = opt.getAttribute('data-price');
          var compareHtml = opt.getAttribute('data-compare-price');
          var onSale = opt.getAttribute('data-on-sale') === 'true';

          if (priceEl && priceHtml) priceEl.innerHTML = priceHtml;

          if (compareEl) {
            if (onSale && compareHtml) {
              compareEl.innerHTML = compareHtml;
              compareEl.hidden = false;
            } else {
              compareEl.innerHTML = '';
              compareEl.hidden = true;
            }
          }

          if (pricesWrap) {
            pricesWrap.classList.toggle('mmh-product__prices--sale', onSale);
          }

          var imageUrl = opt.getAttribute('data-image');
          if (imageUrl) {
            var img = card.querySelector('[data-mmh-product-image]');
            if (img) {
              img.classList.add('is-swapping');
              var nextSrc = imageUrl;
              var swap = function () {
                img.onload = function () {
                  img.classList.remove('is-swapping');
                  fitHomeProductImage(img);
                };
                img.src = nextSrc;
                if (img.complete) {
                  img.classList.remove('is-swapping');
                  fitHomeProductImage(img);
                }
              };
              setTimeout(swap, 90);
            }
          }

          if (window.MMBranchInventory && typeof window.MMBranchInventory.updateShopCard === 'function') {
            window.MMBranchInventory.updateShopCard(card, opt.value);
          }
        });
      });
    }

    bindVariantSelects();
    fitAllHomeProductImages();

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        state.sort = sortSelect.value || 'featured';
        refresh();
      });
    }

    function initFastTouch() {
      root.addEventListener(
        'pointerdown',
        function (e) {
          var btn = targetClosest(e, '[data-mmh-add], .mmh-carousel-card__add, .mmh-offer__add');
          if (!btn || btn.disabled || !root.contains(btn)) return;
          btn.classList.add('is-pressed');
        },
        { passive: true }
      );
      root.addEventListener(
        'pointerup',
        function (e) {
          var btn = targetClosest(e, '[data-mmh-add], .mmh-carousel-card__add, .mmh-offer__add');
          if (btn) btn.classList.remove('is-pressed');
        },
        { passive: true }
      );
      root.addEventListener(
        'pointercancel',
        function (e) {
          var btn = targetClosest(e, '[data-mmh-add], .mmh-carousel-card__add, .mmh-offer__add');
          if (btn) btn.classList.remove('is-pressed');
        },
        { passive: true }
      );
    }

    function initAdvancedCatalog() {
      var searchInput = root.querySelector('[data-mmh-search-input]');
      var searchClear = root.querySelector('[data-mmh-search-clear]');
      var filterOverlay = document.getElementById('mmhFilterOverlay');
      var filterOpen = root.querySelector('[data-mmh-filter-open]');
      var filterCancel = root.querySelector('[data-mmh-filter-cancel]');
      var filterApply = root.querySelector('[data-mmh-filter-apply]');
      var filterClear = root.querySelector('[data-mmh-filter-clear]');
      var priceMinMobile = root.querySelector('[data-mmh-price-min]');
      var priceMaxMobile = root.querySelector('[data-mmh-price-max]');
      var priceMinDesktop = root.querySelector('[data-mmh-desktop-price-min]');
      var priceMaxDesktop = root.querySelector('[data-mmh-desktop-price-max]');
      var desktopSearch = root.querySelector('[data-mmh-desktop-search]');
      var searchTimer = null;

      rebuildProductIndex();

      function openFilter() {
        if (!filterOverlay) return;
        filterOverlay.hidden = false;
        filterOverlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        syncOverlayClass();
      }

      function closeFilter() {
        if (!filterOverlay) return;
        filterOverlay.classList.remove('is-open');
        filterOverlay.hidden = true;
        document.body.style.overflow = '';
        syncOverlayClass();
      }

      function bindCatalogPick(container) {
        if (!container) return;
        container.addEventListener('click', function (e) {
          var btn = e.target.closest('.mm-cf-btn');
          if (!btn) return;
          container.querySelectorAll('.mm-cf-btn').forEach(function (b) {
            b.classList.remove('is-on');
          });
          btn.classList.add('is-on');
          if (container.id === 'mmhDesktopCatalogGroups') {
            revealedCount = pageSize;
            applyAdvancedFilters('desktop');
          }
        });
      }

      bindCatalogPick(document.getElementById('mmhDesktopCatalogGroups'));
      bindCatalogPick(document.getElementById('mmhMobileCatalogFilters'));

      function applyAdvancedFilters(scope) {
        state.brands = getSelectedBrandValues(scope || 'all');
        state.catalogHandles = getSelectedCatalogHandles(scope || 'all');
        var priceEls =
          scope === 'desktop'
            ? readPriceFromInputs(priceMinDesktop, priceMaxDesktop)
            : scope === 'mobile'
              ? readPriceFromInputs(priceMinMobile, priceMaxMobile)
              : readPriceFromInputs(priceMinMobile || priceMinDesktop, priceMaxMobile || priceMaxDesktop);
        state.priceMin = priceEls.min;
        state.priceMax = priceEls.max;
        if (state.catalogHandles.length) {
          state.filter = 'all';
          chips.forEach(function (c) {
            c.classList.toggle('is-active', c.getAttribute('data-mmh-chip') === 'all');
          });
        }
        revealedCount = pageSize;
        applyFilters();
      }

      function clearAdvancedFilters() {
        root.querySelectorAll('#mmhDesktopBrands input, #mmhMobileBrands input').forEach(function (input) {
          input.checked = false;
        });
        root.querySelectorAll('#mmhDesktopCatalogGroups .mm-cf-btn, #mmhMobileCatalogFilters .mm-cf-btn').forEach(function (btn) {
          btn.classList.remove('is-on');
        });
        [priceMinMobile, priceMaxMobile, priceMinDesktop, priceMaxDesktop].forEach(function (el) {
          if (el) el.value = '';
        });
        state.brands = [];
        state.catalogHandles = [];
        state.priceMin = null;
        state.priceMax = null;
        revealedCount = pageSize;
        applyFilters();
      }

      function onSearchInput(value) {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(function () {
          runSearchUi(value);
        }, 100);
      }

      if (searchInput) {
        searchInput.addEventListener('input', function () {
          onSearchInput(searchInput.value);
        });
      }

      if (searchClear) {
        searchClear.addEventListener('click', function () {
          runSearchUi('');
          if (searchInput) searchInput.focus();
        });
      }

      if (desktopSearch) {
        desktopSearch.addEventListener('input', function () {
          onSearchInput(desktopSearch.value);
        });
        desktopSearch.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            runSearchUi(desktopSearch.value);
          }
        });
      }

      if (filterOpen) filterOpen.addEventListener('click', openFilter);
      if (filterCancel) filterCancel.addEventListener('click', closeFilter);
      if (filterOverlay) {
        filterOverlay.addEventListener('click', function (e) {
          if (e.target === filterOverlay) closeFilter();
        });
      }

      if (filterApply) {
        filterApply.addEventListener('click', function () {
          applyAdvancedFilters('mobile');
          closeFilter();
        });
      }

      if (filterClear) {
        filterClear.addEventListener('click', clearAdvancedFilters);
      }

      var desktopApply = root.querySelector('[data-mmh-desktop-apply]');
      var desktopClear = root.querySelector('[data-mmh-desktop-clear]');
      if (desktopApply) {
        desktopApply.addEventListener('click', function () {
          applyAdvancedFilters('desktop');
        });
      }
      if (desktopClear) desktopClear.addEventListener('click', clearAdvancedFilters);

      var quickTabs = document.getElementById('mmhQuickTabs');
      if (quickTabs) {
        quickTabs.addEventListener('click', function (e) {
          var tab = e.target.closest('.mmh-quick-tab');
          if (!tab) return;
          quickTabs.querySelectorAll('.mmh-quick-tab').forEach(function (t) {
            t.classList.remove('on');
          });
          tab.classList.add('on');
          var h = handleFromCollectionUrl(tab.getAttribute('data-url'));
          state.filter = 'all';
          chips.forEach(function (c) {
            c.classList.toggle('is-active', c.getAttribute('data-mmh-chip') === 'all');
          });
          state.catalogHandles = h && h !== 'all' ? [h] : [];
          root.querySelectorAll('#mmhDesktopCatalogGroups .mm-cf-btn, #mmhMobileCatalogFilters .mm-cf-btn').forEach(function (btn) {
            var btnHandle = handleFromCollectionUrl(btn.getAttribute('data-url'));
            btn.classList.toggle('is-on', !!h && btnHandle === h);
          });
          revealedCount = pageSize;
          applyFilters();
        });
      }

      if (window.MMShopCatalog && root.getAttribute('data-use-catalog') === 'true') {
        window.MMShopCatalog.init({
          catalogUrl: root.getAttribute('data-catalog-url') || '/pages/categories',
          autoCatalog: true,
          tabLimit: parseInt(root.getAttribute('data-catalog-tab-limit'), 10) || 10,
          locale: document.documentElement.lang || 'en',
          allUrl: root.getAttribute('data-locale-prefix')
            ? root.getAttribute('data-locale-prefix') + '/collections/all'
            : '/collections/all',
          allLabel: root.getAttribute('data-is-ar') === '1' ? 'الكل' : 'All',
          allLabelShort: root.getAttribute('data-is-ar') === '1' ? 'الكل' : 'All'
        });
      }
    }

    function initProductPrefetch() {
      if (!list) return;

      var metaEl = list.querySelector('[data-mmh-paginate-meta]');
      if (metaEl) {
        try {
          var meta = JSON.parse(metaEl.textContent);
          prefetchState.pages = meta.pages || 1;
          prefetchState.nextPage = (meta.page || 1) + 1;
          if (prefetchState.nextPage > prefetchState.pages) prefetchState.done = true;
        } catch (e) {
          prefetchState.done = true;
        }
      } else {
        prefetchState.done = true;
      }

      function collectionAjaxUrl(page) {
        var base = (list.getAttribute('data-mmh-collection-url') || '/collections/all').replace(/\/$/, '');
        var view = list.getAttribute('data-mmh-ajax-view') || 'mm-home-products-ajax';
        return base + '?view=' + encodeURIComponent(view) + '&page=' + page;
      }

      function appendFetchedHtml(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var wrap = doc.querySelector('.mm-ajax-home-products');
        if (!wrap) return 0;
        var added = 0;
        Array.prototype.slice.call(wrap.querySelectorAll('[data-mmh-product]')).forEach(function (node) {
          var handle = node.getAttribute('data-handle');
          if (handle && list.querySelector('[data-mmh-product][data-handle="' + handle + '"]')) return;
          list.appendChild(node);
          added++;
        });
        var hasNext = wrap.getAttribute('data-has-next') === 'true';
        if (!hasNext) prefetchState.done = true;
        return added;
      }

      function prefetchNext() {
        if (prefetchState.loading || prefetchState.done) {
          applyFilters();
          return Promise.resolve();
        }
        prefetchState.loading = true;
        return fetch(collectionAjaxUrl(prefetchState.nextPage), {
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        })
          .then(function (r) {
            if (!r.ok) throw new Error('prefetch failed');
            return r.text();
          })
          .then(function (html) {
            appendFetchedHtml(html);
            prefetchState.nextPage += 1;
            if (prefetchState.nextPage > prefetchState.pages) prefetchState.done = true;
            refreshCardsFromDom();
            applyFilters();
          })
          .catch(function () {
            prefetchState.done = true;
          })
          .finally(function () {
            prefetchState.loading = false;
            applyFilters();
            if (!prefetchState.done) {
              setTimeout(prefetchNext, 250);
            }
          });
      }

      if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', function () {
          revealedCount += pageSize;
          applyFilters();
          /* Keep prefetching silently in the background */
          if (!prefetchState.done && !prefetchState.loading) prefetchNext();
        });
      }

      /* Prefetch remaining pages in background — do not show Load more for remote-only state */
      if (!prefetchState.done) {
        setTimeout(prefetchNext, 400);
      } else {
        applyFilters();
      }
    }

    function initCatalogDeepLinks() {
      var params = new URLSearchParams(window.location.search);
      var q = params.get('q');
      var brand = params.get('brand');

      if (brand) {
        state.brands = [String(brand).toLowerCase()];
        root.querySelectorAll('#mmhDesktopBrands input, #mmhMobileBrands input').forEach(function (input) {
          input.checked = String(input.value).toLowerCase() === state.brands[0];
        });
      }

      if (q) {
        runSearchUi(q);
      }

      function scrollToCatalog() {
        var catalog = document.getElementById('mmh-catalog');
        if (!catalog) return;
        var top = catalog.getBoundingClientRect().top + window.pageYOffset - 8;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }

      if (window.location.hash === '#mmh-catalog' || q || brand) {
        setTimeout(scrollToCatalog, 120);
      }

      document.querySelectorAll('a[href*="#mmh-catalog"]').forEach(function (link) {
        link.addEventListener('click', function (e) {
          var prefix = root.getAttribute('data-locale-prefix') || '';
          var onHome =
            window.location.pathname === '/' ||
            window.location.pathname === prefix ||
            window.location.pathname === prefix + '/';
          if (onHome) {
            e.preventDefault();
            scrollToCatalog();
          }
        });
      });
    }

    function initCoupons() {
      var openBtn = root.querySelector('[data-mmh-coupons-open]');
      var modal = root.querySelector('[data-mmh-coupons-modal]');
      if (!openBtn || !modal) return;

      var copyLabel = root.getAttribute('data-lbl-coupon-copy') || 'Copy';
      var copiedLabel = root.getAttribute('data-lbl-coupon-copied') || 'Copied';

      function closeCoupons() {
        modal.classList.remove('is-open');
        modal.hidden = true;
        var filterOverlay = document.getElementById('mmhFilterOverlay');
        if (!filterOverlay || !filterOverlay.classList.contains('is-open')) {
          document.body.style.overflow = '';
        }
      }

      openBtn.addEventListener('click', function () {
        modal.hidden = false;
        requestAnimationFrame(function () {
          modal.classList.add('is-open');
        });
        document.body.style.overflow = 'hidden';
      });

      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeCoupons();
      });

      modal.querySelectorAll('[data-mmh-coupons-close]').forEach(function (btn) {
        btn.addEventListener('click', closeCoupons);
      });

      modal.querySelectorAll('[data-mmh-coupon-copy]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var code = btn.getAttribute('data-code') || '';
          if (!code) return;

          function onCopied() {
            btn.classList.add('is-copied');
            btn.textContent = copiedLabel;
            setTimeout(function () {
              btn.classList.remove('is-copied');
              btn.textContent = copyLabel;
            }, 2000);
          }

          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).then(onCopied).catch(function () {
              fallbackCopy(code);
              onCopied();
            });
          } else {
            fallbackCopy(code);
            onCopied();
          }
        });
      });

      function fallbackCopy(text) {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        try {
          document.execCommand('copy');
        } catch (err) {}
        document.body.removeChild(ta);
      }
    }

    initCoupons();
    initAdvancedCatalog();
    initFastTouch();
    initCatalogDeepLinks();
    initProductPrefetch();
    if (window.MMBranchInventory && list) {
      window.MMBranchInventory.init(list);
    }
    window.addEventListener('mm:currency-change', refresh);

    function initBannerSlider() {
      var wrap = root.querySelector('[data-mmh-banners]');
      if (!wrap) return;
      var track = wrap.querySelector('[data-mmh-banners-track]');
      if (!track) return;

      var slides = track.querySelectorAll('.mmh-banner');
      var dots = wrap.querySelectorAll('[data-mmh-banner-dot]');
      if (slides.length <= 1) return;

      var rtl =
        wrap.getAttribute('data-mmh-banners-rtl') === '1' ||
        document.documentElement.getAttribute('dir') === 'rtl';
      var index = 0;
      var timer = null;
      var mq = window.matchMedia('(min-width: 769px)');

      function isDesktop() {
        return mq.matches;
      }

      function update() {
        if (!isDesktop()) {
          track.style.transform = '';
          return;
        }
        var offset = rtl ? index * 100 : -index * 100;
        track.style.transform = 'translateX(' + offset + '%)';
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }

      function goTo(i) {
        index = ((i % slides.length) + slides.length) % slides.length;
        update();
      }

      function next() {
        goTo(index + 1);
      }

      function stop() {
        if (timer) clearInterval(timer);
        timer = null;
      }

      function start() {
        stop();
        if (isDesktop()) timer = setInterval(next, 4000);
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(parseInt(dot.getAttribute('data-mmh-banner-dot'), 10) || 0);
          start();
        });
      });

      if (mq.addEventListener) {
        mq.addEventListener('change', function () {
          index = 0;
          update();
          start();
        });
      }

      wrap.addEventListener('mouseenter', stop);
      wrap.addEventListener('mouseleave', start);

      update();
      start();
    }

    initBannerSlider();

    (function initRestockedFallback() {
      var forceMarketApi = currentCountry() === 'SA';
      var section = root.querySelector('[data-mmh-restocked-section]');
      var track = root.querySelector('[data-mmh-restocked-carousel]');
      if (!section || !track) return;

      var hasLiquidCards = track.children.length > 0;
      if (!forceMarketApi && hasLiquidCards) return;

      var days = parseInt(root.getAttribute('data-restocked-days'), 10) || 30;
      var limit = parseInt(root.getAttribute('data-restocked-limit'), 10) || 100;
      var isAr = root.getAttribute('data-is-ar') === '1';
      var localePrefix = (root.getAttribute('data-locale-prefix') || '').replace(/\/$/, '');

      function cardKey(handle, variantId) {
        return String(handle || '').toLowerCase() + ':' + String(variantId || '');
      }

      function handleFromCard(card) {
        var link = card.querySelector('a[href*="/products/"]');
        if (!link || !link.href) return '';
        var match = String(link.getAttribute('href') || link.href).match(/\/products\/([^/?#]+)/i);
        return match ? match[1] : '';
      }

      function filterLiquidCardsByApi(items) {
        var allowed = {};
        (items || []).forEach(function (item) {
          if (!item || !item.handle || !item.variantId) return;
          allowed[cardKey(item.handle, item.variantId)] = true;
        });

        var visible = 0;
        Array.prototype.forEach.call(track.children, function (card) {
          if (!card || !card.classList || !card.classList.contains('mmh-carousel-card')) return;
          var handle = handleFromCard(card);
          var btn = card.querySelector('[data-variant-id]');
          var variantId = btn && btn.getAttribute('data-variant-id');
          var show = !!allowed[cardKey(handle, variantId)];
          card.hidden = !show;
          if (show) visible += 1;
        });
        section.hidden = visible === 0;
      }

      function shopMoneyDivisor() {
        var div = parseInt(document.documentElement.getAttribute('data-mm-money-divisor'), 10);
        return div === 1000 ? 1000 : 100;
      }

      function normalizeFeedMinor(minor, feedDivisor, skip) {
        if (skip) {
          var direct = parseInt(minor, 10);
          return Number.isFinite(direct) && direct > 0 ? direct : 0;
        }
        var n = parseInt(minor, 10);
        if (!Number.isFinite(n) || n <= 0) return 0;
        var appDiv = parseInt(feedDivisor, 10) || 100;
        var shopDiv = shopMoneyDivisor();
        if (appDiv > shopDiv && appDiv % shopDiv === 0) {
          return Math.round(n / (appDiv / shopDiv));
        }
        return n;
      }

      function formatDirectMoney(minor, currency) {
        var n = parseInt(minor, 10);
        if (!Number.isFinite(n)) return '';
        var code = String(currency || '').toUpperCase();
        var div = code === 'BHD' ? shopMoneyDivisor() : 100;
        var decimals = code === 'BHD' ? 3 : 2;
        var symbol = code || 'SAR';
        if (code === 'SAR') symbol = (document.documentElement.lang || '').indexOf('ar') === 0 ? 'ر.س' : 'SAR';
        if (code === 'BHD') symbol = (document.documentElement.lang || '').indexOf('ar') === 0 ? 'د.ب' : 'BHD';
        var value = (n / div).toFixed(decimals);
        return (document.documentElement.lang || '').indexOf('ar') === 0
          ? value + ' ' + symbol
          : symbol + ' ' + value;
      }

      function formatMinorPrice(minor, currency) {
        var n = parseInt(minor, 10);
        if (!Number.isFinite(n)) return '';
        var code = String(currency || '').toUpperCase();
        if (code === 'SAR' || code === 'AED' || code === 'KWD' || code === 'OMR' || code === 'QAR') {
          return formatDirectMoney(n, code === 'SAR' ? 'SAR' : code);
        }
        if (typeof window.mmFormatMoneyHtml === 'function') {
          return window.mmFormatMoneyHtml(n);
        }
        return formatDirectMoney(n, 'BHD');
      }

      function readExchangeRate() {
        var fromHtml = parseFloat(
          String(document.documentElement.getAttribute('data-mm-exchange-rate') || '').replace(',', '.')
        );
        if (!isNaN(fromHtml) && fromHtml > 0) return fromHtml;
        return 10;
      }

      function isLikelyMislabeledSar(minor) {
        var n = parseInt(minor, 10) || 0;
        if (n <= 0) return false;
        var rate = readExchangeRate();
        var asSarDirect = n / 100;
        var asBhdToSar = (n / shopMoneyDivisor()) * rate;
        if (asSarDirect <= 0 || rate <= 1) return false;
        var ratio = asBhdToSar / asSarDirect;
        return Math.abs(ratio - rate) < 1.5 && asSarDirect < 30;
      }

      function applyStorefrontVariantPrice(item, variant) {
        if (!item || !variant || variant.price == null) return;
        if (String(item.priceCurrency || '').toUpperCase() === 'SAR') return;

        item.priceMinor = variant.price;
        item.priceCurrency = '';
        item.priceFromStorefront = true;

        if (variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
          item.compareMinor = variant.compare_at_price;
          item.compareCurrency = '';
        } else {
          item.compareMinor = null;
          item.compareCurrency = '';
        }
      }

      function variantLabelOnly(variantTitle, productTitle) {
        var label = String(variantTitle || '').trim();
        if (!label || label === 'Default Title') return '';
        var product = String(productTitle || '').trim();
        if (product) {
          var prefix = product + ' - ';
          if (label.indexOf(prefix) === 0) {
            label = label.slice(prefix.length).trim();
          }
        }
        return label;
      }

      function enrichItemLocalized(item) {
        if (!item || !item.handle) return Promise.resolve(null);
        var productUrl = (localePrefix || '') + '/products/' + item.handle + '.js';
        return fetch(productUrl, { credentials: 'same-origin' })
          .then(function (r) {
            if (!r.ok) return null;
            return r.json();
          })
          .then(function (p) {
            if (!p || !p.handle) return item;
            if (p.title) item.title = p.title;
            if (p.variants && item.variantId) {
              var vid = String(item.variantId);
              for (var i = 0; i < p.variants.length; i++) {
                if (String(p.variants[i].id) === vid) {
                  if (p.variants[i].title && p.variants[i].title !== 'Default Title') {
                    item.variantTitle = p.variants[i].title;
                  }
                  applyStorefrontVariantPrice(item, p.variants[i]);
                  break;
                }
              }
            }
            return item;
          })
          .catch(function () {
            return null;
          });
      }

      function buildCard(item, feedDivisor) {
        if (!item || !item.handle || !item.variantId) return null;
        var url = item.url || '/products/' + item.handle + '?variant=' + item.variantId;
        if (localePrefix && url.indexOf('http') !== 0 && url.indexOf(localePrefix) !== 0) {
          url = localePrefix + url;
        }
        var skipMinorNormalize =
          item.priceFromStorefront === true ||
          String(item.priceCurrency || '').toUpperCase() === 'SAR';
        var priceMinor = normalizeFeedMinor(
          item.priceMinor != null ? item.priceMinor : item.price,
          feedDivisor,
          skipMinorNormalize
        );
        var compareMinor = normalizeFeedMinor(
          item.compareMinor != null ? item.compareMinor : item.compareAtPrice,
          feedDivisor,
          skipMinorNormalize
        );
        var priceCurrency = item.priceCurrency || '';
        var compareCurrency = item.compareCurrency || item.priceCurrency || '';
        if (String(priceCurrency).toUpperCase() === 'SAR' && isLikelyMislabeledSar(priceMinor)) {
          priceCurrency = '';
        }
        if (String(compareCurrency).toUpperCase() === 'SAR' && isLikelyMislabeledSar(compareMinor)) {
          compareCurrency = '';
        }
        var sale = Number(compareMinor) > Number(priceMinor) && Number(priceMinor) > 0;

        var article = document.createElement('article');
        article.className = 'mmh-carousel-card';

        var imgWrap = document.createElement('div');
        imgWrap.className = 'mmh-carousel-card__img';

        var link = document.createElement('a');
        link.className = 'mmh-carousel-card__link';
        link.href = url;
        link.setAttribute('aria-label', item.title || '');
        if (item.image) {
          var img = document.createElement('img');
          img.src = item.image;
          img.alt = item.title || '';
          img.loading = 'lazy';
          img.width = 200;
          img.height = 200;
          link.appendChild(img);
        }
        imgWrap.appendChild(link);

        var tag = document.createElement('span');
        tag.className = 'mmh-carousel-card__tag mmh-carousel-card__tag--restocked';
        tag.textContent = isAr ? 'توفر من جديد' : 'Back to stock';
        imgWrap.appendChild(tag);

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mmh-carousel-card__add';
        btn.setAttribute('data-mmh-add', '');
        btn.setAttribute('data-variant-id', item.variantId);
        btn.setAttribute('aria-label', isAr ? 'أضف للسلة' : 'Add to cart');
        btn.textContent = '+';
        imgWrap.appendChild(btn);

        var meta = document.createElement('a');
        meta.className = 'mmh-carousel-card__meta';
        meta.href = url;

        var title = document.createElement('div');
        title.className = 'mmh-carousel-card__title';
        title.textContent = item.title || '';
        meta.appendChild(title);

        var variantLabel = variantLabelOnly(item.variantTitle, item.title);
        if (variantLabel && item.signal !== 'reactivated') {
          var variantEl = document.createElement('div');
          variantEl.className = 'mmh-carousel-card__variant';
          variantEl.textContent = variantLabel;
          meta.appendChild(variantEl);
        }

        var prices = document.createElement('div');
        prices.className = 'mmh-carousel-card__prices' + (sale ? ' mmh-carousel-card__prices--sale' : '');
        var nowPrice = document.createElement('span');
        nowPrice.className = 'mmh-carousel-card__now';
        nowPrice.innerHTML = formatMinorPrice(priceMinor, priceCurrency);
        prices.appendChild(nowPrice);
        if (sale) {
          var was = document.createElement('span');
          was.className = 'mmh-carousel-card__was';
          was.innerHTML = formatMinorPrice(compareMinor, compareCurrency);
          prices.appendChild(was);
        }
        meta.appendChild(prices);
        article.appendChild(imgWrap);
        article.appendChild(meta);
        return article;
      }

      if (forceMarketApi && hasLiquidCards) {
        section.hidden = true;
      }

      fetch(
        '/apps/mm-app/api/restocked?days=' +
          encodeURIComponent(days) +
          '&limit=' +
          encodeURIComponent(limit) +
          '&country=' +
          encodeURIComponent(currentCountry()) +
          '&sync=1&_ts=' +
          Date.now(),
        { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } }
      )
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          var items = data && data.items ? data.items : [];
          if (forceMarketApi && hasLiquidCards) {
            filterLiquidCardsByApi(items);
            return;
          }

          if (forceMarketApi) {
            track.innerHTML = '';
            section.hidden = true;
          }

          var feedDivisor = (data && data.minorDivisor) || 100;
          return Promise.all(
            items.map(function (item) {
              return enrichItemLocalized(item);
            })
          ).then(function (enriched) {
            enriched.forEach(function (item) {
              if (!item) return;
              var card = buildCard(item, feedDivisor);
              if (card) track.appendChild(card);
            });
            section.hidden = track.children.length === 0;
          });
        })
        .catch(function () {
          section.hidden = true;
        });
    })();

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mmh-add]');
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      e.stopPropagation();
      var vid = btn.getAttribute('data-variant-id');
      if (!vid) return;

      var card = btn.closest('[data-mmh-product], .mmh-carousel-card, .mmh-offer');
      var img = card && card.querySelector('img');
      var imageUrl = img ? img.currentSrc || img.src : '';

      btn.disabled = true;
      btn.classList.add('is-adding');
      btn.classList.remove('is-added', 'is-error');

      var addFn =
        window.MMShop && typeof window.MMShop.addToCart === 'function'
          ? window.MMShop.addToCart
          : null;

      var promise = addFn
        ? addFn(vid, { quantity: 1, sourceElement: btn, imageUrl: imageUrl, openSheet: true })
        : Promise.reject(new Error('no cart api'));

      promise
        .then(function (data) {
          btn.classList.add('is-added');
          var handle =
            (data && data.handle) ||
            (card && card.getAttribute('data-handle')) ||
            (card && card.getAttribute('data-recent-handle'));
          if (handle) rememberRecentHandle(handle);
          setTimeout(function () {
            btn.classList.remove('is-added');
          }, 1400);
        })
        .catch(function () {
          btn.classList.add('is-error');
          if (window.MMShop && typeof window.MMShop.showToast === 'function') {
            window.MMShop.showToast(
              document.documentElement.lang === 'ar'
                ? 'تعذّر الإضافة للسلة. حاول مرة أخرى.'
                : 'Could not add to cart. Please try again.',
              true
            );
          }
          setTimeout(function () {
            btn.classList.remove('is-error');
          }, 1600);
        })
        .finally(function () {
          btn.disabled = false;
          btn.classList.remove('is-adding');
        });
    });

    function rememberRecentHandle(handle) {
      if (!handle) return;
      try {
        var key = 'mmh_recent_handles';
        var stored = JSON.parse(localStorage.getItem(key) || '[]');
        stored = stored.filter(function (h) {
          return h !== handle;
        });
        stored.unshift(handle);
        stored = stored.slice(0, 12);
        localStorage.setItem(key, JSON.stringify(stored));
      } catch (err) {}
    }

    function existingRecentHandles() {
      if (!recentTrack) return [];
      return Array.prototype.slice
        .call(recentTrack.querySelectorAll('[data-recent-handle]'))
        .map(function (el) {
          return el.getAttribute('data-recent-handle');
        });
    }

    function updateRecentVisibility() {
      if (!recentSection || !recentTrack) return;
      var hasItems = recentTrack.children.length > 0;
      recentSection.hidden = !hasItems;
    }

    function appendRecentHtml(html) {
      if (!recentTrack || !html) return;
      var wrap = document.createElement('div');
      wrap.innerHTML = html.trim();
      Array.prototype.slice.call(wrap.children).forEach(function (node) {
        var handle = node.getAttribute && node.getAttribute('data-recent-handle');
        if (handle && recentTrack.querySelector('[data-recent-handle="' + handle + '"]')) return;
        recentTrack.appendChild(node);
      });
      updateRecentVisibility();
    }

    function loadGuestRecent() {
      if (!recentTrack) return;

      var viewedIds = [];
      var storedHandles = [];
      try {
        viewedIds = JSON.parse(localStorage.getItem('viewedProducts') || '[]');
      } catch (e) {}
      try {
        storedHandles = JSON.parse(localStorage.getItem('mmh_recent_handles') || '[]');
      } catch (e) {}

      var known = existingRecentHandles();
      storedHandles = storedHandles.filter(function (h) {
        return h && known.indexOf(h) === -1;
      });
      viewedIds = viewedIds.filter(function (id) {
        return id && String(id).length > 0;
      });

      if (!storedHandles.length && !viewedIds.length) {
        updateRecentVisibility();
        return;
      }

      var qs = [];
      if (viewedIds.length) qs.push('ids=' + encodeURIComponent(viewedIds.join(',')));
      if (storedHandles.length) qs.push('handles=' + encodeURIComponent(storedHandles.join(',')));

      fetch('/search?view=mm-mobile-recent-ajax&' + qs.join('&'))
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          appendRecentHtml(html);
        })
        .catch(function () {
          updateRecentVisibility();
        });
    }

    refresh();
    rebuildProductIndex();
    if (state.search || state.brands.length) applyFilters();
    loadGuestRecent();
    updateRecentVisibility();
  }

  function boot() {
    document.documentElement.classList.add('mm-mobile-home-page');
    document.querySelectorAll('[data-mm-mobile-home]').forEach(initMobileHome);
  }

  function onResize() {
    document.documentElement.classList.add('mm-mobile-home-page');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('resize', onResize);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector('[data-mm-mobile-home]');
    if (el) initMobileHome(el);
  });
})();
